import { canAccessCorporatePurchasing } from "../corporate-purchasing/corporatePurchasingAccess";
import { normalizeAllowedModules } from "./moduleEntryResolver";

export function hasBusinessUnitWorkspaceAccess(user = {}) {
  if (Number(user?.id) === 1) return true;
  if (typeof user?.has_business_unit_access === "boolean") return user.has_business_unit_access;
  // Older sessions only describe the active BU: do not assume another BU has no access.
  return user?.has_access_to_all_business_units === true
    || (Array.isArray(user?.business_unit_ids) && user.business_unit_ids.length > 0)
    || normalizeAllowedModules(user?.allowed_modules).some((key) => key !== "corporate_purchasing")
    || user?.permissions?.["hotel_settings.view_users_tab"] === true;
}

export function resolveLoginWorkspacePath(user) {
  return canAccessCorporatePurchasing(user) && !hasBusinessUnitWorkspaceAccess(user)
    ? "/corporate-purchasing/tenders"
    : "/select-workspace";
}

export function workspaceAccessKey(user) {
  return JSON.stringify([
    user?.id, user?.business_unit_ids, user?.has_access_to_all_business_units,
    user?.local_business_unit_ids, hasBusinessUnitWorkspaceAccess(user),
  ]);
}

export function filterWorkspaceBusinessUnits(units, user) {
  if (!hasBusinessUnitWorkspaceAccess(user)) return [];
  const allUnits = Number(user?.id) === 1 || user?.has_access_to_all_business_units === true;
  const memberships = new Set((user?.business_unit_ids || []).map(String));
  const localIds = Array.isArray(user?.local_business_unit_ids)
    ? new Set(user.local_business_unit_ids.map(String)) : null;
  const seen = new Set();
  return (Array.isArray(units) ? units : []).filter((unit) => {
    const id = String(unit?.id ?? "");
    if (!Number.isSafeInteger(Number(id)) || Number(id) <= 0 || seen.has(id)) return false;
    if (!allUnits && !memberships.has(id)) return false;
    if (localIds && !localIds.has(id)) return false;
    seen.add(id);
    return true;
  });
}
